import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import React, { PropsWithChildren } from "react";

import { ProductTileClickImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { ProductTileViewImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileViewImpressionProvider";

interface IProductTileImpressionProviderProps {
  onClickEventName: string | undefined;
  requestId: string | undefined;
  featuredProductToken: string | undefined;
}

export const ProductTileImpressionProvider: React.FC<
  PropsWithChildren<IProductTileImpressionProviderProps>
> = ({ children, onClickEventName, requestId, featuredProductToken}) => {
  const context = `${ProductTileContainer.DISCOVER_PAGE_FEATURED_PRODUCTS_CAROUSEL}|${onClickEventName ?? ""}` as const;


  return (
    <ProductTileViewImpressionProvider
      context={context}
      requestId={requestId}
      screenContext={ProductTileScreen.DISCOVER_PAGE_SCREEN}
      containerContext={onClickEventName as ProductTileScreenContainer}
      contextToken={featuredProductToken || ""}
    >
      <ProductTileClickImpressionProvider
        context={context}
        requestId={requestId}
        productTileContainer={ProductTileContainer.DISCOVER_PAGE_FEATURED_PRODUCTS_CAROUSEL}
        containerName={onClickEventName}
        screenContext={ProductTileScreen.DISCOVER_PAGE_SCREEN}
        containerContext={onClickEventName as ProductTileScreenContainer}
        contextToken={featuredProductToken || ""}
      >
        {children}
      </ProductTileClickImpressionProvider>
    </ProductTileViewImpressionProvider>
  );
};
